import { Media } from '@typings/Media';
import { LibraryFolderStore } from '../Library/LibraryFolder';
import { BaseSelection } from './BaseSelection';

export class VideoSelection extends BaseSelection<Media> {
  private readonly folder: LibraryFolderStore;

  // Legacy property for backward compatibility
  get selectedVideos() {
    return this.selectedItems;
  }

  // Legacy method for backward compatibility
  toggleVideoSelection(videoId: string) {
    this.setIsSelecting(true);
    return this.toggleSelection(videoId);
  }

  // Legacy method for backward compatibility
  selectAllVideos() {
    return this.selectAll();
  }

  constructor(folder: LibraryFolderStore) {
    super();
    this.folder = folder;
  }

  protected getAvailableItems(): Media[] {
    return this.folder.files ?? [];
  }

  protected getItemId(item: Media): string {
    return item._id;
  }
}
